import { lazy } from 'react'

export const AddingReleaseStartPage = lazy(() => import('./AddingReleaseStartPage'))
    